var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$parent.projects.length)?_c('ProjectWrapepr',{attrs:{"parent":_vm.$parent}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }